import { render, staticRenderFns } from "./PlanSummaryWidget.vue?vue&type=template&id=d340a298"
import script from "./PlanSummaryWidget.vue?vue&type=script&lang=ts"
export * from "./PlanSummaryWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports